import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { ITEM_WARRANTIES } from '../../common/constants';
import { selectItemFormData } from '../../store/selectors/itemForm';
import { selectFormOptions } from '../../store/selectors/formOptions';
import { setItemFormData, clearItemFormData } from '../../store/actions/itemForm';
import Button from '../Button';
import Col from '../Col';
import Form, { Heading } from '../Form';
import Input from '../Input';
import Row from '../Row';
import Select from '../Select';
import MultiSelect from 'react-select';

import { connect } from 'react-redux';
import { saveItem } from '../../services/client';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { selectValidation } from '../../store/selectors/Validation';
import { clearValidation } from '../../store/actions/validation';
import { fetchProperties } from '../../store/actions/properties';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectProperties } from '../../store/selectors/properties';
import Checkbox from '../Checkbox';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';


class ItemForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonPressed: '',
    }
  }
  async componentDidMount () {
    const { user, onFetchProperties, itemFormData, onSetItemFormData, properties } = this.props;
    onFetchProperties(user.id, user.roles[0].role.name, true, itemFormData && itemFormData.id ? 'edit': 'add')
    if(itemFormData && itemFormData.id) {
      onSetItemFormData({ isSelectAll: itemFormData.properties.length === properties.length ? true : false })
    }
  }
  onChange(e){
      let type =  this.props.formOptions.allItemTypes.filter( type => type.value === e.target.value);
      this.props.onSetItemFormData({ typeId:e.target.value,typeName:type[0].label})
  }
  saveItem(){
    const { itemFormData, onClose, onSaveItem, onSetItemFormData,formOptions } = this.props;
    onSaveItem(itemFormData);
   // onClose();

  }

  // saveAndAddItem(){
  //   const { itemFormData, onClose, onSaveItem, onSetItemFormData,formOptions,clearItemFormData } = this.props;
  //   onSaveItem(itemFormData);
  //   // setItemFormData({
  //   //   name:'',
  //   //   model:'',
  //   //   makeName:'',
  //   //   typeId:'',
  //   //   warrantyYears:""

  //   // })

  //   clearItemFormData()

  // }


  componentDidUpdate () {
    const { validation, onClose, clearItemFormData, clearValidation } = this.props;
    if(validation.status === true) {
      if(validation.message === 'Item' && this.state.buttonPressed === 'SaveAndClose') {
        onClose();
        clearItemFormData();
        clearValidation();
      } else if(validation.message === 'Item' && this.state.buttonPressed === 'SaveAndAdd') {
        clearItemFormData();
        clearValidation();
      }
    }
  }
  onSelectAll = () => {
    const { itemFormData, properties, onSetItemFormData } = this.props;
    if(itemFormData.isSelectAll && itemFormData.isSelectAll === true) {
      onSetItemFormData({ 
        selectedProperties: [], 
        isSelectAll: false })
    } else {
      onSetItemFormData({ 
         selectedProperties: properties && properties.length > 0 ? properties.map(pty => ({value : pty.id, label: pty.name})) : [],
         isSelectAll: true})
    }
  }
  render() {
    const { itemFormData, onClose, onSaveItem, onSetItemFormData,formOptions, loader, prloader, properties } = this.props;
    return (
      <Form
        headline={(itemFormData.id ? 'Edit' : 'Add an') + ' Item'}
        onClose={onClose}
        onSubmit={() => this.saveItem()}

        actions={(
          <>
            {loader || prloader ? <Loader center={true}/> : null}
            { !itemFormData.id ? <Button
              color="semantic"
              size="small"
              label="Save and Add Another"
              disabled={!itemFormData.name || !itemFormData.typeId || !itemFormData.warrantyYears || !itemFormData.selectedProperties.length}
             // onClick={ () => this.saveAndAddItem()}
              onClick={()=> this.setState({
               buttonPressed:'SaveAndAdd'
              })}
            /> : <div/>}
            <Button
              color="teal"
              size="small"
              label="Save Item"
              disabled={!itemFormData.name || !itemFormData.typeId || !itemFormData.warrantyYears || !itemFormData.selectedProperties.length}
             // onClick={ () => this.saveItem()}
              onClick={()=> this.setState({
               buttonPressed:'SaveAndClose'
              })}
            />
          </>
        )}
        component={(
          <>
            <Row mdCenter>
              <Col
                xs="12"
                md="6"
              >
                <Heading>Item Details</Heading>
                <Input
                  value={itemFormData.name}
                  onChange={e => onSetItemFormData({ name: e.target.value })}
                  label="Name/Description"
                  placeholder="eg., Microwave"
                  required
                  block
                />
               
               <label className="file__label">Property<div className="select__required" /></label>
                <Checkbox
                    value={itemFormData.isSelectAll && itemFormData.isSelectAll === true}
                    label='All Properties'
                    onChange={this.onSelectAll}
                />
                <MultiSelect
                  value={itemFormData.selectedProperties ? itemFormData.selectedProperties : []}
                  closeMenuOnSelect={false}
                  isMulti
                  onChange={values => onSetItemFormData({ selectedProperties: values, isSelectAll: values.length === properties.length ? true : false })}
                  options={properties && properties.length > 0 ? properties.map(pty => ({value : pty.id, label: pty.name})) : []}
                />
                
                <Select
                  value={itemFormData.typeId ? itemFormData.typeId : ''}
                  placeholder="(Select Type)"
                  onChange={e => this.onChange(e)}
                  options={formOptions.allItemTypes}
                  label="Type"
                />
                <Select
                  value={itemFormData.warrantyYears ? itemFormData.warrantyYears : ''}
                  placeholder="(Select Warranty)"
                  onChange={e => onSetItemFormData({ warrantyYears: e.target.value })}
                  options={ITEM_WARRANTIES.map(itemWarranty => ({ value: itemWarranty, label: `${itemWarranty === 0 ? 'NA' : itemWarranty } ${ itemWarranty === 0 ? '' : 'year'}${itemWarranty > 1 ? 's' : ''}` }))}
                  label="Warranty"
                />
                <Input
                  value={itemFormData.makeName}
                  onChange={e => onSetItemFormData({ makeName: e.target.value })}
                  label="Make"
                  placeholder="eg., Samsung"
                  block
                />
                <Input
                  value={itemFormData.model}
                  onChange={e => onSetItemFormData({ model: e.target.value })}
                  label="Model"
                  placeholder="eg., BMO700BSS"
                  block
                />
               
              </Col>
            </Row>
          </>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  itemFormData: selectItemFormData(state),
  formOptions:selectFormOptions(state),
  loader: selectFormLoader(state),
  validation: selectValidation(state),
  user: selectAuthenticatedUser(state),
  properties: selectProperties(state),
  prloader: selectPRLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchProperties : fetchProperties,
  onSetItemFormData: setItemFormData,
  clearItemFormData,
  clearValidation: clearValidation
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemForm);
